import React from 'react'

export default function LoadingShop() {
	return (
		<div className="loader-container">
			<span className="loader"/>
			<h1>Der VdS-Webshop wird geladen ...</h1>
		</div>
	)
}